import { ChevronDown, ChevronUp } from "react-feather";
import { Btn, H5 } from "../../../../../AbstractElements";
import { CardHeader } from "reactstrap";
import { ComonLearningHeaderProp } from "../../../../../Type/Learning";

const CommonLearningHeader = ({heading,isOpen,setIsOpen}:ComonLearningHeaderProp) => {
  return (
    <CardHeader className="card-no-border pb-0">
      <H5 className="mb-0">
        <Btn className="btn btn-link d-flex justify-content-between" onClick={() => setIsOpen(!isOpen)}>{heading}
        {isOpen ? <ChevronDown className="m-0" /> : <ChevronUp className="m-0" />}
        </Btn>
      </H5>
    </CardHeader>
  );
};

export default CommonLearningHeader;
